<div class="backModal enCalendar" *ngIf="disableButtonEnter()">
  <div class="margin d-flex justify-content-center">
    <div class="lds-ring esperando">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
<div class="flexContainer login">
  <div class="loginInputWrap" [formGroup]="loginForm" style="margin-top: 65px">
    <div class="tituloInt">{{ 'ACCESS_USUARIOS' | translate }}</div>
    <p *ngIf="error" style="color: red">{{ error }}</p>
    <div
      class="form-group"
    >
      <div class="tit-form-group">
        <label for="usuario">{{ 'USUARIO' | translate }}</label>
      </div>
      <input
        formControlName="usuario"
        #usuario
        type="text"
        class="form-control"
        id="usuario"
        category="ALFANUMERICO"
        [ngClass]="{ 'active-form': isSelected(usuario) }"
        (focus)="focusValue($event)"
      />
    </div>
    <div
      class="form-group"
    >
      <div class="tit-form-group">
        <label for="contrasena">{{ 'CONTRASENA' | translate }}</label>
      </div>
      <input
        formControlName="contrasena"
        #clave
        category="pago"
        type="password"
        class="form-control"
        id="contrasena"
        category="ALFANUMERICO"
        [ngClass]="{ 'active-form': isSelected(clave) }"
        (focus)="focusValue($event)"
      />
    </div>
    <div *ngIf="!estaIniciada()" class="form-group">
      <div class="tit-form-group">
        <label for="cierreEfectivo">{{ 'CAMBIO_INICIAL' | translate }}</label>
      </div>
      <input
        formControlName="importe"
        #importe
        category="DIVISA"
        type="text"
        class="form-control"
        [ngClass]="{ 'active-form': isSelected(importe) }"
        id="importe"
        placeholder="0,00"
        (focus)="focusValue($event)"
      />
    </div>
    <div *ngIf="verSelector()" class="form-group">
      <select
        formControlName="tpvs"
        class="form-control dropdown"
        (change)="selectTPV($event.target)"
      >
        <option value="">{{ 'SELECT_TPV' | translate }}</option>
        <option *ngFor="let tpv of listadoTPVDisponibles" [value]="tpv.VMPath">
          {{ tpv.Nombre }}
        </option>
      </select>
    </div>
    <div>
      <a
        class="GestionarButton aceptar"
        [ngClass]="{ disabled: !dataReady || tpvEnUso || disableButtonEnter() }"
        (click)="login()"
        title="Entrar"
      >
        <ng-container *ngIf="!loging; else loading">
          {{ 'ENTRAR' | translate }}
        </ng-container>
      </a>

      <a
        class="CancelButton"
        (click)="cancelar()"
        title="Cancelar"
      >
        <ng-container>
          {{ 'CANCELAR' | translate }}
        </ng-container>
      </a>

      <ng-container *ngIf="hasEnabledMicrosoftLogin()">
        <div class="divider">
          <div class="divider-line"></div>
          <span>{{ 'O' | translate }}</span>
          <div class="divider-line"></div>
        </div>
      </ng-container>

      <a
        class="GestionarButton aceptar"
        [ngClass]="{ disabled: !dataReady || tpvEnUso || disableButtonEnter() }"
        (click)="loginMSRedirect()"
        title="{{ 'MS_LOGIN' | translate }}"
        *ngIf="hasEnabledMicrosoftLogin() && !hasActiveAccount()"
      >
        <ng-container>
          {{ 'MS_LOGIN' | translate }}
        </ng-container>
      </a>

      <!-- <a
        class="GestionarButton aceptar"
        [ngClass]="{ disabled: !dataReady || tpvEnUso || disableButtonEnter() }"
        title="{{ getLoginAsButtonText() }}"
        *ngIf="hasActiveAccount() && hasEnabledMicrosoftLogin()"
        (click)="loginAsActiveMicrosoftAccount()"
      >
        <ng-container>
          {{ getLoginAsButtonText() }}
        </ng-container>
      </a> -->

      <a
        class="GestionarButton aceptar"
        title="{{ 'LOGOUT_MICROSOFT' | translate }}"
        *ngIf="hasActiveAccount() && hasEnabledMicrosoftLogin()"
        (click)="logoutMSRedirect()"
      >
        <ng-container>
          {{ 'LOGOUT_MICROSOFT' | translate }}
        </ng-container>
      </a>
    </div>
  </div>
  <ng-template #loading class="DetalleBox__noResultsMessage">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </ng-template>
</div>
